/*
 * Copyright (c) 2018. Rezo Zero
 *
 * This file is part of Supreme NTM.
 *
 * Supreme NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file TrackBlock.js
 * @author Ambroise Maupate <ambroise@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import {AbstractBlock} from 'starting-blocks'
import * as log from 'loglevel'
import Dispatcher from '../utils/Dispatcher'
import {
    TRACK_CLICK
} from '../types/EventTypes'

export default class TrackBlock extends AbstractBlock {
    init () {
        super.init()
        log.debug('\t🎧 New track')

        // Values
        this.lyrics = this.$cont.find('.lyrics').html()

        // Binded methods
        this.onClick = this.onClick.bind(this)
    }

    initEvents () {
        super.initEvents()
        this.$cont.on('click', this.onClick)
    }

    destroyEvents () {
        super.destroyEvents()
        this.$cont.off('click', this.onClick)
    }

    onClick () {
        Dispatcher.commit(TRACK_CLICK, this)
    }

    enable () {
        this.$cont.addClass('tracks__item--active')
    }

    disable () {
        this.$cont.removeClass('tracks__item--active')
    }
}



// WEBPACK FOOTER //
// ./webpack/js/blocks/TrackBlock.js